// Lightweight i18n dictionary. Use {phrase} tokens to mark orange-highlighted words.
export const LANGUAGES = [
  { code: "en", label: "English", native: "English" },
  { code: "si", label: "Sinhala", native: "සිංහල" },
  { code: "ta", label: "Tamil", native: "தமிழ்" },
  { code: "it", label: "Italian", native: "Italiano" },
  { code: "fil", label: "Filipino", native: "Filipino" },
  { code: "th", label: "Thai", native: "ไทย" },
  { code: "ro", label: "Romanian", native: "Română" },
  { code: "bn", label: "Bengali", native: "বাংলা" },
  { code: "vi", label: "Vietnamese", native: "Tiếng Việt" },
];

export const translations = {
  en: {
    "nav.home": "Home",
    "nav.services": "Services",
    "nav.coverage": "Coverage",
    "nav.track": "Track Package",
    "nav.offers": "Offers",
    "nav.about": "About Us",
    "nav.support": "Customer Support",
    "nav.login": "Log in",
    "nav.send": "Send a Parcel",
    "common.language": "Language",

    "hero.badge": "Door-to-Door • All of Europe & Beyond",
    "hero.title": "We pick it from {your door}, deliver to {theirs}.",
    "hero.subtitle": "SmartLogistics is your futuristic parcel partner — collecting from any doorstep in Europe and delivering across Sri Lanka, India, Bangladesh, the Philippines and the UK.",
    "hero.send": "Send a Parcel",
    "hero.track": "Track Package",
    "hero.whatsapp": "WhatsApp Us",
    "hero.searchLabel": "DO WE PICK UP FROM YOUR COUNTRY?",
    "hero.searchPlaceholder": "Search your country…",
    "hero.noMatch": "No match — message us on WhatsApp, we're expanding fast!",
    "hero.livePickup": "Live Pickup",
    "hero.courierWay": "Courier on the way",

    "stats.countries": "Countries Served",
    "stats.warehouses": "Global Warehouses",
    "stats.support": "Customer Support",
    "stats.insured": "Insured & Door-to-Door",

    "offers.heading": "Special offers just for you!",
    "offers.sub": "Grab a deal before you send your next parcel.",
    "offers.claim": "Claim on WhatsApp",
    "offers.send": "Send a Parcel",
    "offers.seeAll": "See all offers",

    "footer.tagline": "Door-to-door parcel delivery across Europe and beyond. We pick up from your door and deliver to theirs.",
    "footer.company": "Company",
    "footer.getStarted": "Get Started",
    "footer.contact": "Contact",
    "footer.about": "About Us",
    "footer.services": "Our Services",
    "footer.coverage": "Coverage & Routes",
    "footer.support": "Customer Support",
    "footer.send": "Send a Parcel",
    "footer.createAccount": "Create Account",
    "footer.review": "Leave a Review",
    "footer.faqs": "FAQs",
    "footer.chat": "Chat on WhatsApp",
    "footer.rights": "All rights reserved. Delivering happiness, door to door.",

    "send.eyebrow": "Send a Parcel",
    "send.title": "Ship from any country to any country",
    "send.subtitle": "Pick where you're sending from and to, add the details, and we'll save it for our team and open a pre-filled WhatsApp chat for your quote and bank-transfer payment.",
    "send.submit": "Save & open WhatsApp",

    "track.eyebrow": "Anytime Tracking",
    "track.title": "Track your package",
    "track.subtitle": "Enter your package number and details. We'll open a WhatsApp chat routed to the right desk for your country, and one of our team will reply with your latest status.",
    "track.submit": "Track & open WhatsApp",
  },

  si: {
    "nav.home": "මුල් පිටුව",
    "nav.services": "සේවාවන්",
    "nav.coverage": "ආවරණය",
    "nav.track": "පාර්සලය සොයන්න",
    "nav.offers": "පිරිනැමීම්",
    "nav.about": "අප ගැන",
    "nav.support": "පාරිභෝගික සහාය",
    "nav.login": "පිවිසෙන්න",
    "nav.send": "පාර්සලයක් යවන්න",
    "common.language": "භාෂාව",

    "hero.badge": "දොරින් දොරට • යුරෝපය පුරා සහ ඉන් ඔබ්බට",
    "hero.title": "අපි {ඔබේ දොරෙන්} අරගෙන, {ඔවුන්ට} බෙදාහරිමු.",
    "hero.subtitle": "SmartLogistics යනු ඔබේ නවීන පාර්සල් සහකරුයි — යුරෝපයේ ඕනෑම දොරකඩකින් එකතු කර ශ්‍රී ලංකාව, ඉන්දියාව, බංග්ලාදේශය, පිලිපීනය සහ එක්සත් රාජධානිය පුරා බෙදාහරිමු.",
    "hero.send": "පාර්සලයක් යවන්න",
    "hero.track": "පාර්සලය සොයන්න",
    "hero.whatsapp": "WhatsApp කරන්න",
    "hero.searchLabel": "ඔබේ රටින් අපි එකතු කරනවාද?",
    "hero.searchPlaceholder": "ඔබේ රට සොයන්න…",
    "hero.noMatch": "ගැළපීමක් නැත — WhatsApp හරහා අපට පණිවිඩයක් යවන්න, අපි වේගයෙන් පුළුල් වෙමින්!",
    "hero.livePickup": "සජීවී එකතු කිරීම",
    "hero.courierWay": "කුරියර් පැමිණෙමින්",

    "stats.countries": "සේවය කරන රටවල්",
    "stats.warehouses": "ගෝලීය ගබඩා",
    "stats.support": "පාරිභෝගික සහාය",
    "stats.insured": "රක්ෂණය සහ දොරින් දොරට",

    "offers.heading": "ඔබ වෙනුවෙන්ම විශේෂ පිරිනැමීම්!",
    "offers.sub": "ඔබේ ඊළඟ පාර්සලය යැවීමට පෙර ගනුදෙනුවක් ලබාගන්න.",
    "offers.claim": "WhatsApp හරහා ලබාගන්න",
    "offers.send": "පාර්සලයක් යවන්න",
    "offers.seeAll": "සියලු පිරිනැමීම් බලන්න",

    "footer.tagline": "යුරෝපය පුරා සහ ඉන් ඔබ්බට දොරින් දොරට පාර්සල් බෙදාහැරීම. අපි ඔබේ දොරෙන් අරගෙන ඔවුන්ට බෙදාහරිමු.",
    "footer.company": "සමාගම",
    "footer.getStarted": "ආරම්භ කරන්න",
    "footer.contact": "සම්බන්ධ වන්න",
    "footer.about": "අප ගැන",
    "footer.services": "අපගේ සේවාවන්",
    "footer.coverage": "ආවරණය සහ මාර්ග",
    "footer.support": "පාරිභෝගික සහාය",
    "footer.send": "පාර්සලයක් යවන්න",
    "footer.createAccount": "ගිණුමක් සාදන්න",
    "footer.review": "සමාලෝචනයක් තබන්න",
    "footer.faqs": "නිතර අසන පැන",
    "footer.chat": "WhatsApp හි කතාබහ කරන්න",
    "footer.rights": "සියලු හිමිකම් ඇවිරිණි. දොරින් දොරට සතුට බෙදාහරිමු.",

    "send.eyebrow": "පාර්සලයක් යවන්න",
    "send.title": "ඕනෑම රටකින් ඕනෑම රටකට යවන්න",
    "send.subtitle": "ඔබ යවන්නේ කොහෙන් සහ කොහාටද යන්න තෝරන්න, විස්තර එක් කරන්න, අපි එය අපගේ කණ්ඩායමට සුරකින අතර ඔබේ මිල ගණන් සහ බැංකු මාරු ගෙවීම සඳහා පෙර පුරවන ලද WhatsApp කතාබහක් විවෘත කරමු.",
    "send.submit": "සුරකින්න සහ WhatsApp විවෘත කරන්න",

    "track.eyebrow": "ඕනෑම වේලාවක සොයන්න",
    "track.title": "ඔබේ පාර්සලය සොයන්න",
    "track.subtitle": "ඔබේ පාර්සල් අංකය සහ විස්තර ඇතුළත් කරන්න. අපි ඔබේ රටට අදාළ අංශයට යොමු කළ WhatsApp කතාබහක් විවෘත කරන අතර අපගේ කණ්ඩායමෙන් කෙනෙක් ඔබේ නවතම තත්ත්වය සමඟ පිළිතුරු දෙනු ඇත.",
    "track.submit": "සොයන්න සහ WhatsApp විවෘත කරන්න",
  },

  ta: {
    "nav.home": "முகப்பு",
    "nav.services": "சேவைகள்",
    "nav.coverage": "பரப்பளவு",
    "nav.track": "பார்சலைக் கண்காணி",
    "nav.offers": "சலுகைகள்",
    "nav.about": "எங்களைப் பற்றி",
    "nav.support": "வாடிக்கையாளர் ஆதரவு",
    "nav.login": "உள்நுழை",
    "nav.send": "பார்சல் அனுப்பு",
    "common.language": "மொழி",

    "hero.badge": "வீட்டு வாசல் முதல் வாசல் வரை • ஐரோப்பா முழுவதும்",
    "hero.title": "நாங்கள் {உங்கள் வீட்டு வாசலில்} இருந்து எடுத்து, {அவர்களுக்கு} வழங்குகிறோம்.",
    "hero.subtitle": "SmartLogistics உங்கள் நவீன பார்சல் கூட்டாளி — ஐரோப்பாவின் எந்த வாசலிலிருந்தும் சேகரித்து இலங்கை, இந்தியா, பங்களாதேஷ், பிலிப்பைன்ஸ் மற்றும் இங்கிலாந்து முழுவதும் வழங்குகிறோம்.",
    "hero.send": "பார்சல் அனுப்பு",
    "hero.track": "பார்சலைக் கண்காணி",
    "hero.whatsapp": "WhatsApp செய்யுங்கள்",
    "hero.searchLabel": "உங்கள் நாட்டிலிருந்து நாங்கள் சேகரிக்கிறோமா?",
    "hero.searchPlaceholder": "உங்கள் நாட்டைத் தேடுங்கள்…",
    "hero.noMatch": "பொருத்தம் இல்லை — WhatsApp இல் எங்களுக்கு செய்தி அனுப்புங்கள், நாங்கள் விரைவாக விரிவடைகிறோம்!",
    "hero.livePickup": "நேரடி சேகரிப்பு",
    "hero.courierWay": "கூரியர் வழியில்",

    "stats.countries": "சேவை நாடுகள்",
    "stats.warehouses": "உலகளாவிய கிடங்குகள்",
    "stats.support": "வாடிக்கையாளர் ஆதரவு",
    "stats.insured": "காப்பீடு & வாசல் முதல் வாசல்",

    "offers.heading": "உங்களுக்காக சிறப்பு சலுகைகள்!",
    "offers.sub": "உங்கள் அடுத்த பார்சலை அனுப்பும் முன் ஒரு சலுகையைப் பெறுங்கள்.",
    "offers.claim": "WhatsApp இல் பெறுங்கள்",
    "offers.send": "பார்சல் அனுப்பு",
    "offers.seeAll": "அனைத்து சலுகைகளையும் காண்க",

    "footer.tagline": "ஐரோப்பா முழுவதும் வாசல் முதல் வாசல் வரை பார்சல் வழங்கல். உங்கள் வாசலில் இருந்து எடுத்து அவர்களுக்கு வழங்குகிறோம்.",
    "footer.company": "நிறுவனம்",
    "footer.getStarted": "தொடங்குங்கள்",
    "footer.contact": "தொடர்பு",
    "footer.about": "எங்களைப் பற்றி",
    "footer.services": "எங்கள் சேவைகள்",
    "footer.coverage": "பரப்பளவு & பாதைகள்",
    "footer.support": "வாடிக்கையாளர் ஆதரவு",
    "footer.send": "பார்சல் அனுப்பு",
    "footer.createAccount": "கணக்கை உருவாக்கு",
    "footer.review": "மதிப்பாய்வு எழுதுங்கள்",
    "footer.faqs": "அடிக்கடி கேட்கப்படும் கேள்விகள்",
    "footer.chat": "WhatsApp இல் அரட்டை",
    "footer.rights": "அனைத்து உரிமைகளும் பாதுகாக்கப்பட்டவை. வாசல் முதல் வாசல் வரை மகிழ்ச்சியை வழங்குகிறோம்.",

    "send.eyebrow": "பார்சல் அனுப்பு",
    "send.title": "எந்த நாட்டிலிருந்தும் எந்த நாட்டிற்கும் அனுப்புங்கள்",
    "send.subtitle": "எங்கிருந்து எங்கு அனுப்புகிறீர்கள் என்பதைத் தேர்ந்தெடுத்து, விவரங்களைச் சேர்க்கவும். நாங்கள் அதை எங்கள் குழுவிற்குச் சேமித்து, உங்கள் விலை மற்றும் வங்கி பரிமாற்ற கட்டணத்திற்கான WhatsApp அரட்டையைத் திறப்போம்.",
    "send.submit": "சேமித்து WhatsApp திற",

    "track.eyebrow": "எப்போதும் கண்காணிப்பு",
    "track.title": "உங்கள் பார்சலைக் கண்காணியுங்கள்",
    "track.subtitle": "உங்கள் பார்சல் எண் மற்றும் விவரங்களை உள்ளிடவும். உங்கள் நாட்டிற்கான சரியான பிரிவுக்கு வழிநடத்தப்படும் WhatsApp அரட்டையைத் திறப்போம், எங்கள் குழுவினர் உங்கள் சமீபத்திய நிலையுடன் பதிலளிப்பார்கள்.",
    "track.submit": "கண்காணித்து WhatsApp திற",
  },

  it: {
    "nav.home": "Home",
    "nav.services": "Servizi",
    "nav.coverage": "Copertura",
    "nav.track": "Traccia pacco",
    "nav.offers": "Offerte",
    "nav.about": "Chi siamo",
    "nav.support": "Assistenza clienti",
    "nav.login": "Accedi",
    "nav.send": "Invia un pacco",
    "common.language": "Lingua",

    "hero.badge": "Porta a porta • In tutta Europa e oltre",
    "hero.title": "Lo ritiriamo dalla {tua porta}, lo consegniamo alla {loro}.",
    "hero.subtitle": "SmartLogistics è il tuo partner per le spedizioni — ritiriamo da qualsiasi porta in Europa e consegniamo in Sri Lanka, India, Bangladesh, Filippine e Regno Unito.",
    "hero.send": "Invia un pacco",
    "hero.track": "Traccia pacco",
    "hero.whatsapp": "Scrivici su WhatsApp",
    "hero.searchLabel": "RITIRIAMO DAL TUO PAESE?",
    "hero.searchPlaceholder": "Cerca il tuo paese…",
    "hero.noMatch": "Nessun risultato — scrivici su WhatsApp, ci stiamo espandendo rapidamente!",
    "hero.livePickup": "Ritiro in tempo reale",
    "hero.courierWay": "Corriere in arrivo",

    "stats.countries": "Paesi serviti",
    "stats.warehouses": "Magazzini globali",
    "stats.support": "Assistenza clienti",
    "stats.insured": "Assicurato e porta a porta",

    "offers.heading": "Offerte speciali per te!",
    "offers.sub": "Approfitta di un'offerta prima di inviare il prossimo pacco.",
    "offers.claim": "Richiedi su WhatsApp",
    "offers.send": "Invia un pacco",
    "offers.seeAll": "Vedi tutte le offerte",

    "footer.tagline": "Consegna pacchi porta a porta in tutta Europa e oltre. Ritiriamo dalla tua porta e consegniamo alla loro.",
    "footer.company": "Azienda",
    "footer.getStarted": "Inizia",
    "footer.contact": "Contatti",
    "footer.about": "Chi siamo",
    "footer.services": "I nostri servizi",
    "footer.coverage": "Copertura e rotte",
    "footer.support": "Assistenza clienti",
    "footer.send": "Invia un pacco",
    "footer.createAccount": "Crea un account",
    "footer.review": "Lascia una recensione",
    "footer.faqs": "Domande frequenti",
    "footer.chat": "Chatta su WhatsApp",
    "footer.rights": "Tutti i diritti riservati. Consegniamo felicità, porta a porta.",

    "send.eyebrow": "Invia un pacco",
    "send.title": "Spedisci da qualsiasi paese a qualsiasi paese",
    "send.subtitle": "Scegli da dove e verso dove spedisci, aggiungi i dettagli e li salveremo per il nostro team aprendo una chat WhatsApp precompilata per il preventivo e il pagamento con bonifico.",
    "send.submit": "Salva e apri WhatsApp",

    "track.eyebrow": "Tracciamento sempre disponibile",
    "track.title": "Traccia il tuo pacco",
    "track.subtitle": "Inserisci il numero del pacco e i dettagli. Apriremo una chat WhatsApp indirizzata all'ufficio giusto per il tuo paese e il nostro team ti risponderà con lo stato più recente.",
    "track.submit": "Traccia e apri WhatsApp",
  },

  fil: {
    "nav.home": "Home",
    "nav.services": "Mga Serbisyo",
    "nav.coverage": "Saklaw",
    "nav.track": "Subaybayan ang Pakete",
    "nav.offers": "Mga Alok",
    "nav.about": "Tungkol sa Amin",
    "nav.support": "Suporta sa Customer",
    "nav.login": "Mag-log in",
    "nav.send": "Magpadala ng Pakete",
    "common.language": "Wika",

    "hero.badge": "Pinto sa Pinto • Buong Europa at Higit Pa",
    "hero.title": "Kinukuha namin ito mula sa {iyong pinto}, inihahatid sa {kanila}.",
    "hero.subtitle": "Ang SmartLogistics ay ang iyong makabagong kasosyo sa pakete — kinukuha mula sa anumang pintuan sa Europa at inihahatid sa Sri Lanka, India, Bangladesh, Pilipinas at UK.",
    "hero.send": "Magpadala ng Pakete",
    "hero.track": "Subaybayan ang Pakete",
    "hero.whatsapp": "I-WhatsApp Kami",
    "hero.searchLabel": "KINUKUHA BA NAMIN MULA SA IYONG BANSA?",
    "hero.searchPlaceholder": "Hanapin ang iyong bansa…",
    "hero.noMatch": "Walang tugma — mag-message sa amin sa WhatsApp, mabilis kaming lumalawak!",
    "hero.livePickup": "Live na Pagkuha",
    "hero.courierWay": "Papunta na ang courier",

    "stats.countries": "Mga Bansang Pinagsilbihan",
    "stats.warehouses": "Mga Pandaigdigang Bodega",
    "stats.support": "Suporta sa Customer",
    "stats.insured": "Naka-insure at Pinto sa Pinto",

    "offers.heading": "Mga espesyal na alok para sa iyo!",
    "offers.sub": "Kumuha ng deal bago magpadala ng susunod mong pakete.",
    "offers.claim": "I-claim sa WhatsApp",
    "offers.send": "Magpadala ng Pakete",
    "offers.seeAll": "Tingnan ang lahat ng alok",

    "footer.tagline": "Paghahatid ng pakete pinto sa pinto sa buong Europa at higit pa. Kinukuha namin mula sa iyong pinto at inihahatid sa kanila.",
    "footer.company": "Kumpanya",
    "footer.getStarted": "Magsimula",
    "footer.contact": "Kontak",
    "footer.about": "Tungkol sa Amin",
    "footer.services": "Aming mga Serbisyo",
    "footer.coverage": "Saklaw at Ruta",
    "footer.support": "Suporta sa Customer",
    "footer.send": "Magpadala ng Pakete",
    "footer.createAccount": "Gumawa ng Account",
    "footer.review": "Mag-iwan ng Review",
    "footer.faqs": "Mga FAQ",
    "footer.chat": "Mag-chat sa WhatsApp",
    "footer.rights": "Nakalaan ang lahat ng karapatan. Naghahatid ng saya, pinto sa pinto.",

    "send.eyebrow": "Magpadala ng Pakete",
    "send.title": "Magpadala mula sa anumang bansa papunta sa anumang bansa",
    "send.subtitle": "Piliin kung saan ka nagpapadala, idagdag ang mga detalye, at ise-save namin ito para sa aming team at magbubukas ng WhatsApp chat para sa iyong quote at bayad sa bank transfer.",
    "send.submit": "I-save at buksan ang WhatsApp",

    "track.eyebrow": "Anumang Oras na Pagsubaybay",
    "track.title": "Subaybayan ang iyong pakete",
    "track.subtitle": "Ilagay ang numero at detalye ng iyong pakete. Magbubukas kami ng WhatsApp chat na naka-ruta sa tamang desk para sa iyong bansa, at sasagot ang aming team ng pinakabagong status.",
    "track.submit": "Subaybayan at buksan ang WhatsApp",
  },

  th: {
    "nav.home": "หน้าแรก",
    "nav.services": "บริการ",
    "nav.coverage": "พื้นที่ให้บริการ",
    "nav.track": "ติดตามพัสดุ",
    "nav.offers": "ข้อเสนอ",
    "nav.about": "เกี่ยวกับเรา",
    "nav.support": "ฝ่ายบริการลูกค้า",
    "nav.login": "เข้าสู่ระบบ",
    "nav.send": "ส่งพัสดุ",
    "common.language": "ภาษา",

    "hero.badge": "ถึงหน้าประตู • ทั่วยุโรปและไกลกว่านั้น",
    "hero.title": "เรารับจาก {หน้าประตูของคุณ} ส่งถึง {ปลายทางของพวกเขา}",
    "hero.subtitle": "SmartLogistics คือพันธมิตรพัสดุยุคใหม่ของคุณ — รับจากหน้าประตูใดก็ได้ในยุโรป และจัดส่งทั่วศรีลังกา อินเดีย บังกลาเทศ ฟิลิปปินส์ และสหราชอาณาจักร",
    "hero.send": "ส่งพัสดุ",
    "hero.track": "ติดตามพัสดุ",
    "hero.whatsapp": "แชทกับเราทาง WhatsApp",
    "hero.searchLabel": "เรารับพัสดุจากประเทศของคุณหรือไม่?",
    "hero.searchPlaceholder": "ค้นหาประเทศของคุณ…",
    "hero.noMatch": "ไม่พบผลลัพธ์ — ส่งข้อความหาเราทาง WhatsApp เรากำลังขยายอย่างรวดเร็ว!",
    "hero.livePickup": "รับพัสดุแบบเรียลไทม์",
    "hero.courierWay": "พนักงานกำลังเดินทางมา",

    "stats.countries": "ประเทศที่ให้บริการ",
    "stats.warehouses": "คลังสินค้าทั่วโลก",
    "stats.support": "ฝ่ายบริการลูกค้า",
    "stats.insured": "มีประกันและถึงหน้าประตู",

    "offers.heading": "ข้อเสนอพิเศษสำหรับคุณ!",
    "offers.sub": "รับดีลก่อนส่งพัสดุครั้งต่อไปของคุณ",
    "offers.claim": "รับสิทธิ์ทาง WhatsApp",
    "offers.send": "ส่งพัสดุ",
    "offers.seeAll": "ดูข้อเสนอทั้งหมด",

    "footer.tagline": "บริการจัดส่งพัสดุถึงหน้าประตูทั่วยุโรปและไกลกว่านั้น เรารับจากหน้าประตูของคุณและส่งถึงปลายทาง",
    "footer.company": "บริษัท",
    "footer.getStarted": "เริ่มต้น",
    "footer.contact": "ติดต่อ",
    "footer.about": "เกี่ยวกับเรา",
    "footer.services": "บริการของเรา",
    "footer.coverage": "พื้นที่และเส้นทาง",
    "footer.support": "ฝ่ายบริการลูกค้า",
    "footer.send": "ส่งพัสดุ",
    "footer.createAccount": "สร้างบัญชี",
    "footer.review": "เขียนรีวิว",
    "footer.faqs": "คำถามที่พบบ่อย",
    "footer.chat": "แชททาง WhatsApp",
    "footer.rights": "สงวนลิขสิทธิ์ทั้งหมด ส่งมอบความสุขถึงหน้าประตู",

    "send.eyebrow": "ส่งพัสดุ",
    "send.title": "ส่งจากประเทศใดก็ได้ไปยังประเทศใดก็ได้",
    "send.subtitle": "เลือกต้นทางและปลายทางที่คุณต้องการส่ง กรอกรายละเอียด แล้วเราจะบันทึกให้ทีมงานและเปิดแชท WhatsApp ที่กรอกไว้ล่วงหน้าสำหรับใบเสนอราคาและการชำระเงินผ่านธนาคาร",
    "send.submit": "บันทึกและเปิด WhatsApp",

    "track.eyebrow": "ติดตามได้ทุกเวลา",
    "track.title": "ติดตามพัสดุของคุณ",
    "track.subtitle": "กรอกหมายเลขพัสดุและรายละเอียดของคุณ เราจะเปิดแชท WhatsApp ที่ส่งไปยังแผนกที่ถูกต้องสำหรับประเทศของคุณ และทีมงานของเราจะตอบกลับพร้อมสถานะล่าสุด",
    "track.submit": "ติดตามและเปิด WhatsApp",
  },

  ro: {
    "nav.home": "Acasă",
    "nav.services": "Servicii",
    "nav.coverage": "Acoperire",
    "nav.track": "Urmărește colet",
    "nav.offers": "Oferte",
    "nav.about": "Despre noi",
    "nav.support": "Asistență clienți",
    "nav.login": "Autentificare",
    "nav.send": "Trimite un colet",
    "common.language": "Limbă",

    "hero.badge": "Din ușă în ușă • În toată Europa și dincolo",
    "hero.title": "Îl ridicăm de la {ușa ta} și îl livrăm la {a lor}.",
    "hero.subtitle": "SmartLogistics este partenerul tău modern pentru colete — ridicăm de la orice ușă din Europa și livrăm în Sri Lanka, India, Bangladesh, Filipine și Regatul Unit.",
    "hero.send": "Trimite un colet",
    "hero.track": "Urmărește colet",
    "hero.whatsapp": "Scrie-ne pe WhatsApp",
    "hero.searchLabel": "RIDICĂM DIN ȚARA TA?",
    "hero.searchPlaceholder": "Caută țara ta…",
    "hero.noMatch": "Niciun rezultat — scrie-ne pe WhatsApp, ne extindem rapid!",
    "hero.livePickup": "Ridicare în timp real",
    "hero.courierWay": "Curierul este pe drum",

    "stats.countries": "Țări deservite",
    "stats.warehouses": "Depozite globale",
    "stats.support": "Asistență clienți",
    "stats.insured": "Asigurat și din ușă în ușă",

    "offers.heading": "Oferte speciale pentru tine!",
    "offers.sub": "Profită de o ofertă înainte să trimiți următorul colet.",
    "offers.claim": "Revendică pe WhatsApp",
    "offers.send": "Trimite un colet",
    "offers.seeAll": "Vezi toate ofertele",

    "footer.tagline": "Livrare colete din ușă în ușă în toată Europa și dincolo. Ridicăm de la ușa ta și livrăm la a lor.",
    "footer.company": "Companie",
    "footer.getStarted": "Începe",
    "footer.contact": "Contact",
    "footer.about": "Despre noi",
    "footer.services": "Serviciile noastre",
    "footer.coverage": "Acoperire și rute",
    "footer.support": "Asistență clienți",
    "footer.send": "Trimite un colet",
    "footer.createAccount": "Creează cont",
    "footer.review": "Lasă o recenzie",
    "footer.faqs": "Întrebări frecvente",
    "footer.chat": "Discută pe WhatsApp",
    "footer.rights": "Toate drepturile rezervate. Livrăm fericire, din ușă în ușă.",

    "send.eyebrow": "Trimite un colet",
    "send.title": "Expediază din orice țară către orice țară",
    "send.subtitle": "Alege de unde și unde trimiți, adaugă detaliile, iar noi le salvăm pentru echipa noastră și deschidem un chat WhatsApp precompletat pentru ofertă și plata prin transfer bancar.",
    "send.submit": "Salvează și deschide WhatsApp",

    "track.eyebrow": "Urmărire oricând",
    "track.title": "Urmărește-ți coletul",
    "track.subtitle": "Introdu numărul coletului și detaliile. Vom deschide un chat WhatsApp direcționat către biroul potrivit pentru țara ta, iar echipa noastră îți va răspunde cu cel mai recent status.",
    "track.submit": "Urmărește și deschide WhatsApp",
  },

  bn: {
    "nav.home": "হোম",
    "nav.services": "সেবা",
    "nav.coverage": "কভারেজ",
    "nav.track": "প্যাকেজ ট্র্যাক করুন",
    "nav.offers": "অফার",
    "nav.about": "আমাদের সম্পর্কে",
    "nav.support": "গ্রাহক সহায়তা",
    "nav.login": "লগ ইন",
    "nav.send": "পার্সেল পাঠান",
    "common.language": "ভাষা",

    "hero.badge": "দ্বারে দ্বারে • সমগ্র ইউরোপ ও তার বাইরে",
    "hero.title": "আমরা {আপনার দরজা} থেকে নিয়ে, {তাদের কাছে} পৌঁছে দিই।",
    "hero.subtitle": "SmartLogistics আপনার আধুনিক পার্সেল সঙ্গী — ইউরোপের যেকোনো দরজা থেকে সংগ্রহ করে শ্রীলঙ্কা, ভারত, বাংলাদেশ, ফিলিপাইন ও যুক্তরাজ্য জুড়ে পৌঁছে দেয়।",
    "hero.send": "পার্সেল পাঠান",
    "hero.track": "প্যাকেজ ট্র্যাক করুন",
    "hero.whatsapp": "WhatsApp করুন",
    "hero.searchLabel": "আমরা কি আপনার দেশ থেকে সংগ্রহ করি?",
    "hero.searchPlaceholder": "আপনার দেশ খুঁজুন…",
    "hero.noMatch": "কোনো মিল নেই — WhatsApp-এ আমাদের বার্তা দিন, আমরা দ্রুত সম্প্রসারিত হচ্ছি!",
    "hero.livePickup": "লাইভ পিকআপ",
    "hero.courierWay": "কুরিয়ার আসছে",

    "stats.countries": "সেবাপ্রাপ্ত দেশ",
    "stats.warehouses": "বৈশ্বিক গুদাম",
    "stats.support": "গ্রাহক সহায়তা",
    "stats.insured": "বীমাকৃত ও দ্বারে দ্বারে",

    "offers.heading": "আপনার জন্য বিশেষ অফার!",
    "offers.sub": "আপনার পরবর্তী পার্সেল পাঠানোর আগে একটি ডিল নিন।",
    "offers.claim": "WhatsApp-এ দাবি করুন",
    "offers.send": "পার্সেল পাঠান",
    "offers.seeAll": "সব অফার দেখুন",

    "footer.tagline": "সমগ্র ইউরোপ ও তার বাইরে দ্বারে দ্বারে পার্সেল ডেলিভারি। আমরা আপনার দরজা থেকে নিয়ে তাদের কাছে পৌঁছে দিই।",
    "footer.company": "কোম্পানি",
    "footer.getStarted": "শুরু করুন",
    "footer.contact": "যোগাযোগ",
    "footer.about": "আমাদের সম্পর্কে",
    "footer.services": "আমাদের সেবা",
    "footer.coverage": "কভারেজ ও রুট",
    "footer.support": "গ্রাহক সহায়তা",
    "footer.send": "পার্সেল পাঠান",
    "footer.createAccount": "অ্যাকাউন্ট তৈরি করুন",
    "footer.review": "রিভিউ দিন",
    "footer.faqs": "সাধারণ প্রশ্ন",
    "footer.chat": "WhatsApp-এ চ্যাট করুন",
    "footer.rights": "সর্বস্বত্ব সংরক্ষিত। দ্বারে দ্বারে আনন্দ পৌঁছে দিই।",

    "send.eyebrow": "পার্সেল পাঠান",
    "send.title": "যেকোনো দেশ থেকে যেকোনো দেশে পাঠান",
    "send.subtitle": "কোথা থেকে কোথায় পাঠাচ্ছেন তা নির্বাচন করুন, বিবরণ যোগ করুন, আমরা তা আমাদের দলের জন্য সংরক্ষণ করব এবং আপনার কোটেশন ও ব্যাংক ট্রান্সফার পেমেন্টের জন্য একটি প্রি-ফিল করা WhatsApp চ্যাট খুলব।",
    "send.submit": "সংরক্ষণ করুন এবং WhatsApp খুলুন",

    "track.eyebrow": "যেকোনো সময় ট্র্যাকিং",
    "track.title": "আপনার প্যাকেজ ট্র্যাক করুন",
    "track.subtitle": "আপনার প্যাকেজ নম্বর ও বিবরণ লিখুন। আমরা আপনার দেশের সঠিক ডেস্কে রুট করা একটি WhatsApp চ্যাট খুলব এবং আমাদের দলের একজন সর্বশেষ অবস্থা জানিয়ে উত্তর দেবে।",
    "track.submit": "ট্র্যাক করুন এবং WhatsApp খুলুন",
  },

  vi: {
    "nav.home": "Trang chủ",
    "nav.services": "Dịch vụ",
    "nav.coverage": "Phạm vi",
    "nav.track": "Theo dõi bưu kiện",
    "nav.offers": "Ưu đãi",
    "nav.about": "Về chúng tôi",
    "nav.support": "Hỗ trợ khách hàng",
    "nav.login": "Đăng nhập",
    "nav.send": "Gửi bưu kiện",
    "common.language": "Ngôn ngữ",

    "hero.badge": "Tận nhà • Toàn châu Âu và hơn thế nữa",
    "hero.title": "Chúng tôi lấy từ {cửa nhà bạn}, giao đến {cửa nhà họ}.",
    "hero.subtitle": "SmartLogistics là đối tác bưu kiện hiện đại của bạn — lấy hàng từ bất kỳ cửa nhà nào ở châu Âu và giao đến Sri Lanka, Ấn Độ, Bangladesh, Philippines và Vương quốc Anh.",
    "hero.send": "Gửi bưu kiện",
    "hero.track": "Theo dõi bưu kiện",
    "hero.whatsapp": "Nhắn WhatsApp cho chúng tôi",
    "hero.searchLabel": "CHÚNG TÔI CÓ LẤY HÀNG TỪ NƯỚC BẠN KHÔNG?",
    "hero.searchPlaceholder": "Tìm quốc gia của bạn…",
    "hero.noMatch": "Không có kết quả — nhắn cho chúng tôi trên WhatsApp, chúng tôi đang mở rộng nhanh chóng!",
    "hero.livePickup": "Lấy hàng trực tiếp",
    "hero.courierWay": "Nhân viên đang trên đường",

    "stats.countries": "Quốc gia phục vụ",
    "stats.warehouses": "Kho toàn cầu",
    "stats.support": "Hỗ trợ khách hàng",
    "stats.insured": "Được bảo hiểm & tận nhà",

    "offers.heading": "Ưu đãi đặc biệt dành cho bạn!",
    "offers.sub": "Nhận ưu đãi trước khi gửi bưu kiện tiếp theo.",
    "offers.claim": "Nhận qua WhatsApp",
    "offers.send": "Gửi bưu kiện",
    "offers.seeAll": "Xem tất cả ưu đãi",

    "footer.tagline": "Giao bưu kiện tận nhà khắp châu Âu và hơn thế nữa. Chúng tôi lấy từ cửa nhà bạn và giao đến cửa nhà họ.",
    "footer.company": "Công ty",
    "footer.getStarted": "Bắt đầu",
    "footer.contact": "Liên hệ",
    "footer.about": "Về chúng tôi",
    "footer.services": "Dịch vụ của chúng tôi",
    "footer.coverage": "Phạm vi & tuyến đường",
    "footer.support": "Hỗ trợ khách hàng",
    "footer.send": "Gửi bưu kiện",
    "footer.createAccount": "Tạo tài khoản",
    "footer.review": "Để lại đánh giá",
    "footer.faqs": "Câu hỏi thường gặp",
    "footer.chat": "Trò chuyện trên WhatsApp",
    "footer.rights": "Bảo lưu mọi quyền. Giao niềm vui, tận nhà.",

    "send.eyebrow": "Gửi bưu kiện",
    "send.title": "Gửi từ bất kỳ quốc gia nào đến bất kỳ quốc gia nào",
    "send.subtitle": "Chọn nơi bạn gửi đi và đến, thêm thông tin chi tiết, chúng tôi sẽ lưu lại cho đội ngũ và mở cuộc trò chuyện WhatsApp điền sẵn cho báo giá và thanh toán chuyển khoản ngân hàng.",
    "send.submit": "Lưu và mở WhatsApp",

    "track.eyebrow": "Theo dõi mọi lúc",
    "track.title": "Theo dõi bưu kiện của bạn",
    "track.subtitle": "Nhập số bưu kiện và thông tin của bạn. Chúng tôi sẽ mở cuộc trò chuyện WhatsApp được chuyển đến bộ phận phù hợp cho quốc gia của bạn, và đội ngũ của chúng tôi sẽ trả lời với trạng thái mới nhất.",
    "track.submit": "Theo dõi và mở WhatsApp",
  },
};
